const value = Object.freeze({
  DateChange: 1,
  ScheduleChange: 2,
  AddParticipant: 3,
});
export default value;
